export const NAVIGATION_TRIGGER = {
  BOTTOM_NAVBAR: 'bottom_navbar',
  TOP_NAVBAR: 'top_navbar',
  NAV_DRAWER: 'nav_drawer',
  FOOTER: 'footer',
} as const;

export type NavigationTrigger = (typeof NAVIGATION_TRIGGER)[keyof typeof NAVIGATION_TRIGGER];
